import { authHeader } from '@/helpers/auth-header'
import { commons } from './commons'

export const companyParametersService = {
    getByNameAndCompanyId,
}

const resourceUrl = process.env.VUE_APP_GSCV_ENGINE_URL + `/company-parameters`

function getByNameAndCompanyId(companyId, name) {
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
    }
    return fetch(
        resourceUrl + `/${name}/${companyId}`,
        requestOptions,
    ).then(commons.handleJsonResponse)
}